/**
 * TPL Hero — Scroll indicator, smooth scroll, video observer
 * Extracted from tpl-hero.liquid
 */
(function() {
  const hero = document.querySelector('[data-tpl-hero]');
  const scrollIndicator = document.querySelector('[data-scroll-indicator]');

  if (!hero) return;

  // Hide scroll indicator on scroll
  let hasScrolled = false;
  function handleScroll() {
    if (!hasScrolled && window.scrollY > 100) {
      hasScrolled = true;
      if (scrollIndicator) {
        scrollIndicator.classList.add('is-hidden');
      }
    }
  }

  window.addEventListener('scroll', handleScroll, { passive: true });

  // Reset scroll indicator on back/forward navigation (bfcache)
  window.addEventListener('pageshow', function(e) {
    if (e.persisted && scrollIndicator) {
      hasScrolled = false;
      scrollIndicator.classList.remove('is-hidden');
    }
  });

  // Click scroll indicator to scroll down
  if (scrollIndicator) {
    scrollIndicator.addEventListener('click', function() {
      const heroHeight = hero.offsetHeight;
      const motionOk = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({
        top: heroHeight,
        behavior: motionOk ? 'smooth' : 'auto'
      });
    });
  }

  // Video loading optimization
  const video = hero.querySelector('.tpl-hero__video');
  if (video) {
    // Pause video when not visible (performance)
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            video.play().catch(() => {
              // Autoplay failed silently — poster image remains visible
            });
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.25 }
    );

    observer.observe(hero);
  }
})();
